module.exports = "/_next/static/images/862074c46b2a623acf054ea85951e88e-phone-and-card@xs-2x.jpg";